/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_AvailableInputs */

const en_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Available`)
};

const fr_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour disponible`)
};

const de_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update verfügbar`)
};

const it_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento disponibile`)
};

const ru_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступно обновление`)
};

const es_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización disponible`)
};

const zh_cn2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新可用`)
};

const ja_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデートが利用可能です`)
};

const hi_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्ध अद्यतन`)
};

const pt_pt2_update_available = /** @type {(inputs: Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização disponível`)
};

/**
* | output |
* | --- |
* | "Update Available" |
*
* @param {Update_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_available = /** @type {((inputs?: Update_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_available(inputs)
	if (locale === "de") return de_update_available(inputs)
	if (locale === "it") return it_update_available(inputs)
	if (locale === "ru") return ru_update_available(inputs)
	if (locale === "es") return es_update_available(inputs)
	if (locale === "zh-CN") return zh_cn2_update_available(inputs)
	if (locale === "ja") return ja_update_available(inputs)
	if (locale === "hi") return hi_update_available(inputs)
	if (locale === "pt-PT") return pt_pt2_update_available(inputs)
	return en_update_available(inputs)
});